import { render, staticRenderFns } from "./ServiceTypes.vue?vue&type=template&id=42d36cca&scoped=true&"
import script from "./ServiceTypes.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ServiceTypes.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ServiceTypes.vue?vue&type=style&index=0&id=42d36cca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d36cca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42d36cca')) {
      api.createRecord('42d36cca', component.options)
    } else {
      api.reload('42d36cca', component.options)
    }
    module.hot.accept("./ServiceTypes.vue?vue&type=template&id=42d36cca&scoped=true&", function () {
      api.rerender('42d36cca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/services/index/components/ServiceTypes.vue"
export default component.exports